var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { initOnPageUsers, populateFriends } from './actionCreators';
import { handleActions } from 'redux-actions';
var handler = handleActions((_a = {},
    _a[initOnPageUsers.toString()] = function (state, _a) {
        var payload = _a.payload;
        return __assign(__assign({}, state), { usersOnPage: (payload && payload.users) || false });
    },
    _a[populateFriends.toString()] = function (state, _a) {
        var _b, _c;
        var payload = _a.payload;
        if (!payload) {
            return state;
        }
        var friends = payload.friends, alpha = payload.alpha, page = payload.page;
        return __assign(__assign({}, state), { friends: __assign(__assign({}, state.friends), (_b = {}, _b[alpha] = __assign(__assign({}, state.friends[alpha]), friends), _b)), friendPages: __assign(__assign({}, state.friendPages), (_c = {}, _c[alpha] = page, _c)) });
    },
    _a), { friendPages: {}, friends: {} });
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducers.js.map